// extracted by mini-css-extract-plugin
export default {"LoginForm":"LoginForm_LoginForm__RSGgL","title":"LoginForm_title__MXlRf","fields":"LoginForm_fields__POaPz","formField":"LoginForm_formField__mr2Ra","link":"LoginForm_link__QLdZg"};